import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { CHANNEL_RECORDING_TASK_STATE_TO_LABEL } from '../constants';
import { ChannelRecordingTaskStateEnum } from '../types';

export function useChannelRecordingTaskStateOptions(): SelectOptionProps<ChannelRecordingTaskStateEnum>[] {
  const { t } = useTranslation();

  return [
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.PENDING]),
      value: ChannelRecordingTaskStateEnum.PENDING,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.RUNNING]),
      value: ChannelRecordingTaskStateEnum.RUNNING,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.COMPLETED]),
      value: ChannelRecordingTaskStateEnum.COMPLETED,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.CANCELLED]),
      value: ChannelRecordingTaskStateEnum.CANCELLED,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.ERROR]),
      value: ChannelRecordingTaskStateEnum.ERROR,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.PAUSED]),
      value: ChannelRecordingTaskStateEnum.PAUSED,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.TIMEOUT]),
      value: ChannelRecordingTaskStateEnum.TIMEOUT,
    },
    {
      label: t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[ChannelRecordingTaskStateEnum.REMOVED]),
      value: ChannelRecordingTaskStateEnum.REMOVED,
    },
  ];
}
